import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { TeamsClientOptions } from './context';
import { TeamsClientContext, defaultOptions } from './context';

export interface TeamsClientProviderProps {
  readonly options?: TeamsClientOptions;
}

const TeamsClientProvider: FC<PropsWithChildren<TeamsClientProviderProps>> = ({
  options = defaultOptions,
  children,
}) => <TeamsClientContext.Provider value={options}>{children}</TeamsClientContext.Provider>;

export default TeamsClientProvider;
